import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getMemberByAccessToken } from "../../services/memberPortalService";

import "./MemberPortal.css";

import { generateMemberCard } from "../../utils/generateMemberCard";
import { generateWorkoutPDF } from "../../utils/generateWorkoutPDF";
import { generateDietPDF } from "../../utils/generateDietPDF";

import { getWorkoutPlan } from "../../services/workoutPlanService";
import { getDietPlan } from "../../services/dietPlanService";
import {
  FaIdCard,
  FaDumbbell,
  FaAppleAlt,
  FaUserCircle,
  FaCrown,
  FaUserTie,
  FaCalendarAlt,
} from "react-icons/fa";

export default function MemberPortal() {
  const { token } = useParams();

  const [member, setMember] = useState(null);

  const [gym, setGym] = useState(null);
  const [workoutPlan, setWorkoutPlan] = useState(null);
  const [dietPlan, setDietPlan] = useState(null);

  useEffect(() => {
    loadPortal();
  }, []);

  const loadPortal = async () => {
    const data = await getMemberByAccessToken(token);

    if (!data) return;

    setMember(data.member);
    setGym(data.gym);

    if (data.member.workoutPlanId) {
      const workout = await getWorkoutPlan(
        data.member.workoutPlanId,
        data.gymId,
      );

      setWorkoutPlan(workout);
    }

    if (data.member.dietPlanId) {
      const diet = await getDietPlan(data.member.dietPlanId, data.gymId);

      setDietPlan(diet);
    }
  };

  if (!member) {
    return (
      <h2 style={{ textAlign: "center", marginTop: "100px" }}>
        Invalid Portal Link
      </h2>
    );
  }

  return (
    <div className="portal-container">
      <div className="portal-card">
        {gym?.logo && <img src={gym.logo} className="portal-logo" alt="" />}

        <h1>{gym?.gymName}</h1>

        <h3>Member Portal</h3>

        {member.photo ? (
          <img src={member.photo} className="member-photo" alt="" />
        ) : (
          <div className="photo-placeholder">
            <FaUserCircle size={70} color="#6b7280" />
          </div>
        )}

        <h2>{member.fullName}</h2>

        <span
          className={
            member.status === "Active" ? "status-active" : "status-expired"
          }
        >
          {member.status}
        </span>

        <div className="member-info">
          <p>
            <strong>
              <FaCrown style={{ marginRight: "8px", color: "#f59e0b" }} />
              Membership
            </strong>

            <span>{member.membershipPlan}</span>
          </p>

          <p>
            <strong>
              <FaUserTie style={{ marginRight: "8px", color: "#4f46e5" }} />
              Trainer
            </strong>

            <span>{member.trainerName || "-"}</span>
          </p>

          <p>
            <strong>
              <FaCalendarAlt style={{ marginRight: "8px", color: "#16a34a" }} />
              Expiry
            </strong>

            <span>{member.expiryDate}</span>
          </p>
        </div>

        <div className="download-section">
          <button
            className="download-btn"
            onClick={() => generateMemberCard(member, gym)}
          >
            <FaIdCard style={{ marginRight: "10px" }} />
            Download ID Card
          </button>

          <button
            className="download-btn"
            disabled={!workoutPlan}
            onClick={() => generateWorkoutPDF(member, workoutPlan, gym)}
          >
            <FaDumbbell style={{ marginRight: "10px" }} />
            Download Workout Plan
          </button>

          <button
            className="download-btn"
            disabled={!dietPlan}
            onClick={() => generateDietPDF(member, dietPlan, gym)}
          >
            <FaAppleAlt style={{ marginRight: "10px" }} />
            Download Diet Plan
          </button>
        </div>

        <p className="powered">Powered By NN FIT</p>
      </div>
    </div>
  );
}
